import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProtectedSharePage } from './protected-share.page';

const routes: Routes = [
  {
    path: '',
    component: ProtectedSharePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProtectedSharePageRoutingModule {}
